import GoodsPriceRow, { GOODS_CODE } from '../GoodsPriceRow';

const PopupPAHAB010Tab2 = ({ closePopup, goodsMap }) => {
    return (
        <div className="ticket-pop ">
            <div className="ticket-pop__block">
                <div className="ticket__table">
                    <div className="ticket__grid ticket__grid--head">
                        <span>광고 상품 / 덴탈잡 이용권</span>
                        <span style={{ justifyContent: 'center' }}>
                            <img src=".././images/PAHAB010/popticket_dentalJob.png" alt="popticket_dentalJob" />
                        </span>
                        <span style={{ justifyContent: 'center' }}>
                            <img src=".././images/PAHAB010/popticket_dvmall.png" alt="popticket_dvmall" />
                        </span>
                        <span style={{ justifyContent: 'center' }}>
                            <img src=".././images/PAHAB010/popticket_dvmall_membership.png" alt="popticket_dvmall" />
                        </span>
                    </div>
                    <GoodsPriceRow goods={goodsMap[GOODS_CODE.RECRUIT_NEWS_FIXED]} />
                    {/* <div className="ticket__grid">
                        <span className="left">고정옵션 2주</span>
                        <span>
                            <b>120,000</b>원
                        </span>
                        <span>
                            <b>100,000</b>원
                        </span>
                    </div> */}
                    <GoodsPriceRow goods={goodsMap[GOODS_CODE.HIGHLIGHT_1W]} />
                    <GoodsPriceRow goods={goodsMap[GOODS_CODE.HIGHLIGHT_2W]} />
                    <GoodsPriceRow goods={goodsMap[GOODS_CODE.COLOR_1W]} />
                    <GoodsPriceRow goods={goodsMap[GOODS_CODE.COLOR_2W]} />
                    {/* Chưa có GoodCode trong tblGoods_Master nên vẫn giữ giá cố định */}
                    <div className="ticket__grid">
                        <span className="left">아이콘 강조 1주</span>
                        <span>
                            <b>8,000</b>원
                        </span>
                        <span>
                            <b>7,000</b>원
                        </span>
                        <span>
                            <b>6,300</b>원
                        </span>

                    </div>
                    <div className="ticket__grid">
                        <span className="left">아이콘 강조 2주</span>
                        <span>
                            <b>12,000</b>원
                        </span>
                        <span>
                            <b>11,000</b>원
                        </span>
                        <span>
                            <b>9,900</b>원
                        </span>

                    </div>
                </div>
                <img src=".././images/PAHAB010/popticket_footer.png" alt="popticket_footer" />
                <button className="byn__btn" onClick={closePopup}>
                    가격표 닫기
                </button>
            </div>
        </div>
    );
};
export default PopupPAHAB010Tab2;
